import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BPProfilesAttributesService, DocumentUrlExpression, IProfileAttributeModel } from './bp-profiles-attributes.service';

@Component({
  selector: 'bp-profiles-attributes-value',
  template: `
    <div class="row profile-attribute-value-container" [class.read-mode]="!isEditable" [class.self-attribute-content]="!hasCommentOrDocuments">
      <div [ngClass]="isEditable? 'col-sm-12' : 'col-sm-10'">
        <label class="profile-attribute-description">
          <i class="fa profile-attribute-status-icon" [ngClass]="statusIconClass"></i>
          <span class="description">
            <span>{{profileAttribute.description}}</span>
            <info-link class="profile-attribute-info" [(linkVariable)]="profileAttribute.showInfo" *ngIf="profileAttribute.comment"></info-link>
          </span>
        </label>

        <div class="info-row row" *ngIf="profileAttribute.showInfo">
          <div class="info col-sm-12" [innerHTML]="profileAttribute.comment"></div>
          <ng-container *ngIf="profileAttribute.faq">
            <faq-item [faqData]="profileAttribute.faq" [collapsible]="true"></faq-item>
          </ng-container>
        </div>
      </div>
      
      <div class="col-sm-2" *ngIf="!isEditable">
        <p class="profile-attribute-value">{{attributeValue | translate}}</p>
      </div>

      <div class="col-sm-10" *ngIf="!isEditable && profileAttribute.attributeValue?.comment">
        <p class="profile-attribute-comment-value" [innerHTML]="profileAttribute.attributeValue?.comment"></p>  
      </div>
      
      <div class="col-sm-10" *ngIf="!isEditable && profileAttribute.attributeValue.documents?.length">
        <p class="profile-attribute-documents-link">
          <span *ngFor="let document of profileAttribute.attributeValue.documents; trackById" class="link">
            <a [href]="getDocumentUrl ? getDocumentUrl(profileAttribute.id, document.id) : ''" target="_self">{{document.description}}</a>
          </span>
        </p>
      </div>
    </div>
  `
})
export class BPProfilesAttributesValueComponent implements OnChanges {
  @Input() public profileAttribute:IProfileAttributeModel;
  @Input() public isEditable:boolean;
  @Input() public showInfo:boolean;
  @Input() public getDocumentUrl:DocumentUrlExpression;

  constructor(
    private bpProfilesAttributesService:BPProfilesAttributesService
  ) {
    /**/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.showInfo) {
      this.profileAttribute.showInfo = changes.showInfo.currentValue;
    }
  }

  public get statusIconClass():string {
    return this.bpProfilesAttributesService.getStatusIcon(this.profileAttribute);
  }

  public get attributeValue():string {
    return this.bpProfilesAttributesService.formatAttributeValueLabel(this.profileAttribute);
  }

  public get hasCommentOrDocuments():boolean {
    return !!this.profileAttribute.attributeValue?.comment || !!this.profileAttribute.attributeValue?.documents?.length;
  }
}